import Image from 'next/image';
import Link from 'next/link';
import { PopupMedia } from '@/components/PagePopup';
import { PopupActions, PopupContent } from '@/components/PagePopup/PopupContent';
import { Button } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
import { InstagramMonthlyGiveaway2026Popup as PopupData } from '@/constants/popups';
import type { PagePopupProps, PopUpPosition, PopUpVariant } from '@/components/PagePopup/PagePopup';
const homepageRegex = /^\/$/;
const aboutRegex = /^\/about(?:[/?#]|$)/;
export const getInstagramMonthlyGiveaway2026Props = ({
  forceShowGiveaway,
  giveawayPopupIsHidden,
  logPopupClick,
  asPath
}: {
  forceShowGiveaway?: boolean;
  giveawayPopupIsHidden?: boolean;
  logPopupClick: (type: string, popup_id: string, nextPath: string) => void;
  asPath: string;
}): PagePopupProps | null => {
  const popupId = 'instagram-monthly-giveaway-september-2026';
  return {
    storageKey: popupId,
    variant: 'default' as PopUpVariant,
    position: 'bottom-right' as PopUpPosition,
    duration: forceShowGiveaway ? undefined : {
      from: new Date(Date.parse('2026-09-17T00:00:00Z')),
      to: new Date(Date.parse('2026-12-31T23:59:59Z'))
    },
    excludeSlugs: [homepageRegex, aboutRegex, '/pricing', '/my/account', '/music/latest-releases', '/refer-and-earn'],
    delay: 10_000,
    isHidden: giveawayPopupIsHidden,
    children: <PopupContent mainTitle={PopupData.mainTitle} subtitle={PopupData.subtitle} variant="default">
        <Text className="font-sans text-gray-700 text-sm">
          {PopupData.description}
        </Text>
        <div className="relative aspect-[16/7] overflow-hidden rounded-lg">
          <Image alt={PopupData.imgAlt} className="h-auto w-full -translate-y-4" height={360 / (16 / 7)} // height is proportionate to the aspect ratio of 16:7
        src={PopupData.imgSrc} width={360 - 44} // width minus horizontal padding
        // NOTE: Avoided using fill or the PopupMedia component because of aliasing issues
        />
        </div>
        <PopupActions>
          <Button border className="text-sm" onClick={() => {
          // onClickDismiss logs this once DISMISS_POPUP reaches PagePopup
          window.postMessage({
            type: 'DISMISS_POPUP'
          }, '*');
        }} variant="subtle">
            Dismiss
          </Button>
          <Button asChild className="text-sm" onClick={() => {
          window.postMessage({
            type: 'DISMISS_POPUP'
          }, '*');
        }} variant="bold">
            <Link href={PopupData.href} onClick={() => {
            logPopupClick('cta', popupId, PopupData.href);
          }} rel="noopener" target="_blank">
              {PopupData.cta}
            </Link>
          </Button>
        </PopupActions>
      </PopupContent>,
    onClickDismiss: () => {
      logPopupClick('dismiss', popupId, asPath);
    },
    noXIcon: {
      desktop: false,
      mobile: false
    },
    mobileChildren: <PopupContent href={PopupData.href} mainTitle={PopupData.mainTitle} onHrefClick={() => {
      window.postMessage({
        type: 'DISMISS_POPUP'
      }, '*');
      logPopupClick('cta', popupId, PopupData.href);
    }} subtitle={PopupData.subtitle} variant="mobile-banner-image">
        <PopupMedia variant="mobile-banner-image">
          <Image alt={PopupData.imgAlt} className="min-h-[96px] w-full object-cover" height={96} src={PopupData.imgSrc} width={96 * (16 / 9)} />
        </PopupMedia>
      </PopupContent>
  };
};